import React, { useState, useEffect } from "react";
// import congratsBannerBg from "../../../../../../../assets/congratsBannerBg.png";
import ProfileCard from "../ProfileCard";
import Confetti from "react-confetti";

const CongratulationsPage = ({ formData, onContinue }) => {
      const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      onContinue();
    }, 5000);
    return () => clearTimeout(timer);
  }, [onContinue]);

  return (
    <div className="w-full h-full flex flex-col">
         <Confetti
        width={windowDimensions.width}
        height={windowDimensions.height}
        recycle={false}
        numberOfPieces={500}
        gravity={0.3}
      />
      {/* <img src={congratsBannerBg} alt="background" className="absolute inset-0 w-full h-full object-cover" /> */}
      
      <div className="relative z-10 w-full max-w-6xl mx-auto">
         <div className="text-center mb-5 md:mb-2">
          <h1 className="text-2xl md:text-2xl lg:text-[32px] font-gotham font-medium text-[#323232] mb-3">
            Congratulations on hitting the 1st milestone in your journey.
          </h1>
          <div className="flex justify-end max-w-4xl mx-auto mt-4">
            <div className="w-20 h-2 bg-[#54B0AF] rounded-full"></div>
          </div>
        </div>

        <div className="max-w-[429px] mx-auto">
          <ProfileCard formData={formData} editableName={false} headerLabel="Current State" />
        </div>
      </div>
    </div>
  );
};

export default CongratulationsPage;